export const painPoints = [
  {
    title: 'Plata tirada',
    body: 'Frutas y verduras que se pudren en el cajón porque no sabés cómo usarlas.',
  },
  {
    title: 'Comida chatarra',
    body: 'Al no tener nada listo, terminás comiendo cualquier cosa por falta de tiempo.',
  },
  {
    title: 'Corridas matutinas',
    body: 'Madrugar para armar una vianda de apuro que los chicos ni siquiera terminan.',
  },
  {
    title: 'Cocina siempre sucia',
    body: 'Lavar ollas y sartenes todos los días, dos veces al día.',
  },
]

export const outcomes = [
  {
    title: 'Domingos de Victoria',
    body: 'Terminás en 3 horas y te olvidás de prender la hornalla hasta el viernes.',
  },
  {
    title: 'Viandas de cole perfectas',
    body: 'Almuerzos nutritivos que los chicos AMAN y vos solo tenés que pasar del freezer a la mochila.',
  },
  {
    title: 'Heladera de revista',
    body: 'Todo en recipientes, rotulado y listo para consumir.',
  },
  {
    title: 'Ahorro de supervivencia',
    body: 'Comprás solo lo que necesitás. Ni un peso de más.',
  },
]

export type StackItem = {
  kind: 'main' | 'bonus'
  label: string
  name: string
  detail: string
  value: string
}

export const stack: StackItem[] = [
  {
    kind: 'main',
    label: 'Guía principal',
    name: 'Cocina en 3 Horas',
    detail: 'El paso a paso completo del método.',
    value: '$15.000',
  },
  {
    kind: 'bonus',
    label: 'Bono 1',
    name: 'Lista de Compras Inteligente',
    detail: 'Segmentada por sector del súper.',
    value: '$4.000',
  },
  {
    kind: 'bonus',
    label: 'Bono 2',
    name: 'Guía de Freezer y Conservación',
    detail: 'Tiempos exactos y tips de almacenamiento.',
    value: '$5.500',
  },
  {
    kind: 'bonus',
    label: 'Bono 3',
    name: 'Recetario de Viandas Escolares',
    detail: 'Fórmulas "anti-rechazo" probadas con chicos.',
    value: '$6.000',
  },
  {
    kind: 'bonus',
    label: 'Bono 4',
    name: 'Menú Semanal descargable',
    detail: 'Para imprimir y pegar en la heladera.',
    value: '$3.500',
  },
  {
    kind: 'bonus',
    label: 'Bono 5',
    name: 'Manual de Cenas en 10 minutos',
    detail: 'Para los imprevistos de cualquier día.',
    value: '$4.500',
  },
]

export const faqs = [
  {
    q: '¿Tengo que cocinar platos raros?',
    a: 'No. Son recetas argentinas, ricas y fáciles. La clave está en la organización, no en ingredientes exóticos.',
  },
  {
    q: '¿La comida se mantiene rica?',
    a: '¡Claro! Te enseñamos las técnicas exactas de almacenamiento para que el viernes la comida sepa igual de fresca que el domingo.',
  },
  {
    q: 'No tengo muchos recipientes, ¿sirve igual?',
    a: 'Sí, podés empezar con lo que tengas y te damos consejos para comprar los recipientes correctos sin gastar de más.',
  },
]

export const CTA_LABEL = '🍱 ¡SÍ! QUIERO COCINAR EN 3 HORAS'

export const CHECKOUT_URL = 'https://cocina-en-3-horas.impultienda.ar/checkout'
